export const cristal = {
  legalage: {
    title: ' ',
    button1: <span style={{ fontSize: '11px'}}>SI, SOY MAYOR</span>,
    button2: <span style={{ fontSize: '11px'}}>NO, SOY MENOR</span>,
  },
  agegate: {
    title: '¿Listo para ganar con Carta Blanca?',
  },
  signup: {
    title: 'Bienvenido',
    description: 'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar tus latas para completar la colección. Consigue las 26 latas de Amstel Ultra y descubre los mensajes de Rafa Nadal.'
  },
  start: {
    signup: 'REGÍSTRATE CON CORREO',
    signin: 'ENTRA CON CORREO',
    social: 'ENTRA CON:',
    title: {
      html:
        <div className="flex-1 w-full py-2 flex flex-col items-center justify-center">
          <img src={`${AZURE_BASE_URL}/fondo-inicial.png`} alt="background" />
        </div>
    }
  },
  home: {
    title: <span className="font-light" style={{ color: '#CF202F', fontSize: '21px', }}>¿QUÉ quieres hacer?</span>,
    description: '¡Completa tus datos!'
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '¿CÓMO SE LLAMA?',
          placeholder: 'Ponga su nombre aquí'
        },
        lastname: {
          placeholder: 'Ponga su apellido aquí',
        },
        nickname: {
          label: '¿APODO?',
          placeholder: '¿Como le gusta que le digan?'
        },
        gender: {
          label: '¿CÓMO SE IDENTIFICA?'
        }
      }
    },
    information: 'DATOS PERSONALES',
    address: 'DIRECCIÓN',
    contact: 'CONTACTO',
    button: 'IR A VER LOS PREMIOS',
    identification: {
      nav: 'MI CRISTAL ID',
      title: 'CRISTAL ID',
      button: 'DESCARGAR CRISTAL ID'
    },
  },
  config: {
    prizes: '/prizes'
  },
  congrats: {
    range: {
      title: "NUEVO LOGRO DESBLOQUEADO",
      description: <></>,
      description2: <>Felicitaciones, has desbloqueado nuevos <br /> premios y obtienes más chances de ganar.</>
    }
  },
  endroute: {
    title: <>¡Lo sentimos! <br /> Esto es solo <br /> para mayores</>,
    description: 'Vuelve cuando sea más grande.'
  },
  referrals: {
    description: 'Comparte tu código con amigos y gana más oportunidades de ganar.',
    subtitle: 'COMPARTE TU CÓDIGO Y GANA',
    left: 'COPIAR',
    right: 'COMPARTIR'
  },
  trivias: {
    exchange: {
      button: {
        text: 'SEGUIR JUGANDO',
        url: '/trivias'
      }
    },
    triviaQr: {
      register: {
        title: <div className="text-white">CONTESTA<br /><span style={{ color: '#CCB988' }}>Y GANA</span></div>,
        description: <div className="text-white">
          <p>¿Ya tienes tu CRISTAL ID?</p>
          <b className="mt-3">SI NO LO TIENES CÓRRELE A REGISTRARTE PARA PODER PARTICIPAR</b>
          <img className="mx-auto mt-5" src="https://promohubstorage.blob.core.windows.net/cristal/assets/crista_id_ej.svg" />
        </div>
      },
      late: {
        description: <p className="text-white">Lamentablemente esta trivia ya no está disponible. Busca nuevo QR dentro de las otras dinámicas que tenemos para ti, para contestar una trivia nueva</p>
      }
    },
    questions1: <>Contesta </>,
    questions2: <> <span className="font-bold" style={{ color: '#CCB988'}}>preguntas</span> sobre el tema y gana:</>,
  },
  survey: {
    title: 'CUÉNTANOS DE TI',
    button: 'RESPONDER'
  },
  mail: {
    description: <>Has confirmado con éxito tu cuenta. <br/> Te esperan muchas sorpresas en el <br/> MACROFEST 2023</>
  },
  prizes: {
    start: {
      title: <span style={{ fontFamily: 'Montserrat', fontWeight: 800, fontSize: '25px'}}>PREMIOS</span>
    }
  }

}